import axios from "axios";
import config  from '../../env.json';


function getDestTables(callback:any){
  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/dataverse/getdatamappingdestinationtabledetails',
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
}
function getDestTableColumns(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/dataverse/getdatamappingdestinationtabledetailsbyId',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function sendSoucerData(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/dataverse/sourcedatainsert',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function sendSoucerCSVData(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/dataverse/sourceCSVdatainsert',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function submitDataMapping(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/dataverse/datamappingins',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function getSalesForceData(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/thirdpartytoolconnection/salesforce/contact',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}

 
function getCRMData(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/thirdpartytoolconnection/crm/contact',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}


function getAllMappingDetails(callback:any){
  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/dataverse/getdatamappingimportdetails',
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
}
 
function deleteImportbyId(payload:any,callback:any){
  try {
    axios({
      method: 'delete',
      url:config.REACT_APP_ENV_API_BASE+'/dataverse/deletedatamappingimportdetailbyid?Id='+payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
}
 
 

export {sendSoucerData,submitDataMapping,getSalesForceData,getCRMData,sendSoucerCSVData,getDestTables,getDestTableColumns,deleteImportbyId,getAllMappingDetails}